import {FieldType} from "../../manager/FieldType";
import {Chip} from "./Chip";
import {attributeGroups} from "./attributeGroups";
import {toolbox} from "./toolbox";
import {FieldTypeManager} from "../../manager/FieldTypeManager";

export const chipFieldType: FieldType = {
  name: 'chip',
  component: Chip,
  attributeGroups: attributeGroups,
  toolbox,
};

FieldTypeManager.register(chipFieldType.name, chipFieldType);
